/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { positionChangeWidthSm, promptsArray } from '../../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../../helpers/textfields'
import { selectElementWithIndex } from '../../../../helpers/selects'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX, hobbiesElementsJSX } from '../../../../helpers/commonJSX'

export const hobbiesJSX = (
  bioObject, setBioObject,
  newHobbies, setNewHobbies,
  loadingHobbies, setLoadingHobbies,
  saveSuccessful, setSaveSuccessful, resetSaveSuccessful,
  bioErrors, setBioErrors,
  width
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('newHobbies.length ->', newHobbies.length)
    // console.log('bioObject.hobbies.length ->', bioObject.hobbies.length)
    // console.log('indexes all equal ->', bioObject.hobbies.filter((hobby, index) => hobby !== newHobbies[index]).length === 0)

    return !(
      newHobbies.length > 0
      && bioObject.hobbies.length > 0
      && newHobbies.length === bioObject.hobbies.length
      && bioObject.hobbies.filter((hobby, index) => (index > newHobbies.length) || (hobby !== newHobbies[index])).length === 0
    )
  }

  const handleBioItemChange = (e, setErrors, setForm, form, index) => {
    e.preventDefault()

    setBioErrors({ ...bioErrors, hobbies: false })
    // setSaveSuccessful({ ...saveSuccessful, hobbies: false })
    resetSaveSuccessful()

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('index ->', index)

    if (name === 'hobbies' && value !== ' ') {
      const updatedHobbies = [ ...newHobbies ]
      updatedHobbies[index] = value
      setForm([ ...updatedHobbies ])
    } 
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')


    setBioErrors({ ...bioErrors, hobbies: false })
    // setSaveSuccessful({ ...saveSuccessful, hobbies: false })
    resetSaveSuccessful()

    setNewHobbies([ ...bioObject.hobbies ])
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')
    const objectToUpload = {
      hobbies: [ ...newHobbies ],
    }

    // Upload Modifications
    if (objectToUpload.hobbies.length > 0 
      && 
      !(
        objectToUpload.hobbies.length === bioObject.hobbies.length
        && bioObject.hobbies.filter((hobbyItem, index) => hobbyItem !== objectToUpload.hobbies[index]).length === 0
      )
    ) {
      console.log('attempting upload hobbies')
      setLoadingHobbies(true)
      setBioErrors({ ...bioErrors, hobbies: false })
      // setSaveSuccessful({ ...saveSuccessful, hobbies: false })
      resetSaveSuccessful()
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${bioObject._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        setBioObject({ ...bioObject, hobbies: [ ...objectToUpload.hobbies ] })

        setBioErrors({ ...bioErrors, hobbies: false })
        setSaveSuccessful({ ...saveSuccessful, hobbies: true })
        setLoadingHobbies(false)
        
      } catch (error) {
        console.log(error)
        setBioErrors({ ...bioErrors, hobbies: true })
        // setSaveSuccessful({ ...saveSuccessful, hobbies: false })
        // resetSaveSuccessful()
        setLoadingHobbies(false)
      }
    }

  }

  // Hobbies JSX
  const hobbiesJSX = () => {
    return (
      <>
        {hobbiesElementsJSX('reviewerBio', newHobbies, false, handleBioItemChange, setBioErrors, newHobbies, setNewHobbies)}
      </>
    )
  }

  return (
    <Box
      sx={{
        py: 3, my: 2,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Hobbies Section */}
        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Hobbies/Interests', 
          '*Up to 5 hobbies/interests',
          0
        )}
  
        {/* Hobbies JSX */}
        {hobbiesJSX()}

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons() &&
          saveAndCancelButtonsJSX(
            loadingHobbies,
            !(showSaveAndCancelButtons() || loadingHobbies),
            handleCancelPressed,
            handleSavePressed,
            0,
            bioErrors.hobbies ? 0 : 2,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loadingHobbies &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {bioErrors.hobbies &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.hobbies &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}